import React, { useState, useEffect } from "react";
import { Modal, Input, Form, Row, Col, Typography, Select, message } from "antd";
import { platformApi } from "../../../../api";

const { Item } = Form;
const { Text, Title } = Typography;
const { Option } = Select;

const LocalityForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [editable, setEditable] = useState(props.editable);
  const [cities, setCities] = useState([]);

  const { form, open, close, data, modify, emitData } = props;
  const { getFieldDecorator, setFieldsValue, resetFields, validateFields } = form;

  useEffect(() => {
    setEditable(props.editable);
    if (data) {
      setFieldsValue({
        city: data.city || (data.City ? data.City.id : undefined),
        pinCode: data.pinCode,
        localityName: data.localityName,
      });
    }
  }, [data, props.editable]);

  useEffect(() => {
    if (open) {
      fetchCities();
    }
  }, [open]);

  const fetchCities = () => {
    platformApi
      .get("/api/csc/city/all")
      .then((res) => {
        if (res.data && res.data.code === 200) {
          setCities(res.data.data || []);
        }
      })
      .catch((err) => {
        console.error("Error fetching cities for Locality form:", err);
        message.error("Failed to load cities");
      });
  };

  const handleSubmit = () => {
    validateFields((err, values) => {
      if (!err) {
        setLoading(true);
        const payload = {
          city: values.city,
          pinCode: values.pinCode ? values.pinCode.trim() : "",
          localityName: values.localityName.trim(),
        };
        if (data && data.id) {
          payload.id = data.id;
        }
        emitData(payload);
        setLoading(false);
        resetFields();
        close();
      }
    });
  };

  return (
    <Modal
      title={<Title level={4}>{data && data.id ? (editable ? "Edit Locality" : "View Locality") : "Add Locality"}</Title>}
      visible={open}
      okText={editable ? "Save" : "Modify"}
      onCancel={() => {
        resetFields();
        close();
      }}
      okButtonProps={{ loading, disabled: !modify && !editable }}
      onOk={() => (editable ? handleSubmit() : setEditable(true))}
    >
      <Form layout="vertical">
        {/* Field 1: *City */}
        <Row type="flex" justify="space-between">
          <Col span={24}>
            <Item label={<Text strong>City</Text>} colon={false} required>
              {getFieldDecorator("city", {
                rules: [{ required: true, message: "Please select city!" }],
              })(
                <Select
                  disabled={!editable}
                  placeholder="Select City"
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) => {
                    const label = Array.isArray(option.props.children)
                      ? option.props.children.join("")
                      : String(option.props.children || "");
                    return label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                  }}
                >
                  {cities.map((c) => {
                    const labelText = c.State ? `${c.name} (${c.State.name})` : c.name;
                    return (
                      <Option key={c.id} value={c.id}>
                        {labelText}
                      </Option>
                    );
                  })}
                </Select>
              )}
            </Item>
          </Col>
        </Row>

        {/* Field 2: *Pin Code */}
        <Row type="flex" justify="space-between">
          <Col span={24}>
            <Item label={<Text strong>Pin Code</Text>} colon={false} required>
              {getFieldDecorator("pinCode", {
                rules: [
                  { required: true, message: "Please enter pin code!" },
                  { pattern: /^[0-9]{6}$/, message: "Please enter a valid 6-digit pin code!" },
                ],
              })(
                <Input
                  disabled={!editable}
                  placeholder="Enter Pin Code (e.g. 560034)"
                  maxLength={6}
                />
              )}
            </Item>
          </Col>
        </Row>

        {/* Field 3: *Locality Name */}
        <Row type="flex" justify="space-between">
          <Col span={24}>
            <Item label={<Text strong>Locality Name</Text>} colon={false} required>
              {getFieldDecorator("localityName", {
                rules: [{ required: true, message: "Please enter locality name!" }],
              })(
                <Input
                  disabled={!editable}
                  placeholder="Enter Locality Name (e.g. Koramangala 4th Block)"
                  maxLength={150}
                />
              )}
            </Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

const WrappedLocalityModal = Form.create({ name: "locality_form" })(LocalityForm);

export default WrappedLocalityModal;

